module.exports = __webpack_public_path__ + "img/老师.330b5372.png";